
import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({ children, className = '', onClick }) => {
  return (
    <div className={`bg-surface-card text-foreground shadow-md rounded-md p-6 border border-border ${className}`} onClick={onClick}>
      {children}
    </div>
  );
};

export default Card;
